export default "__VITE_ASSET__Dn430QXE__"